function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import { MedicalRecordContext } from 'context';
import { SECONDS_IN_DAY } from 'helpers/datetime';
import ActiveNotingLabel from 'components/ActiveNotingLabel';
import Widget from 'components/Widget';
import * as constants from 'modules/PatientResults/constants';
import messages from 'modules/PatientResults/messages';
import { GlucoseConcentrationLevels } from 'modules/PatientResults/modules/Charts';
import CGMTimePercentage from './CGMTimePercentage';
import styles from './GlucoseConcentrationLevelsWidget.pcss';
const GlucoseConcentrationLevelsWidget = ({ readings, className, start, end, isInProgress, onAddNote })=>{
    const medicalRecord = useContext(MedicalRecordContext);
    useStyles(styles);
    if (!medicalRecord) {
        return null;
    }
    const dayLen = Math.ceil((end - start) / SECONDS_IN_DAY);
    const { dataType } = medicalRecord;
    if (dataType === 'CGM' && dayLen === 1) {
        return null;
    }
    const headerMessage = dataType === 'BGM' ? messages.glucoseConcentrationLevels.header : messages.glucoseConcentrationLevels.cgmHeader;
    return /*#__PURE__*/ _jsxs(Widget, {
        widgetId: constants.GLUCOSE_CONCENTRATION_LEVELS_WIDGET,
        headerMessage: headerMessage,
        children: [
            onAddNote ? /*#__PURE__*/ _jsx(ActiveNotingLabel, {
                labelMessage: messages.noting.clickLevel
            }) : null,
            /*#__PURE__*/ _jsx("div", {
                className: styles.container,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: styles.content,
                    children: [
                        dataType === 'BGM' && /*#__PURE__*/ _jsxs("div", {
                            className: styles.summary,
                            children: [
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.glucoseConcentrationLevels.totalReadings)),
                                /*#__PURE__*/ _jsx("span", {
                                    children: `: ${readings.length}`
                                })
                            ]
                        }),
                        dataType === 'CGM' && /*#__PURE__*/ _jsx("div", {
                            className: styles.cgmBeneficial,
                            children: "Each 5% increase is clinically beneficial"
                        }),
                        /*#__PURE__*/ _jsx(GlucoseConcentrationLevels, {
                            readings: readings,
                            className: className,
                            isInProgress: isInProgress,
                            onAddNote: onAddNote
                        }),
                        /*#__PURE__*/ _jsx(CGMTimePercentage, {
                            readings: readings
                        })
                    ]
                })
            })
        ]
    }, "GlucoseConcentrationLevelsWidget");
};
export default GlucoseConcentrationLevelsWidget;
